import React, { Component } from 'react'

import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react'
import { Row, Col, Label } from 'reactstrap'
import { AUX } from '../../../../hoc'
import { CurrencyMX } from '../../../UI/Currency'

const google_maps_key = "AIzaSyDWCW427GCChgnNDE6heI1n79NHnuRy-iQ"


export class MapProperties extends Component {

    state = {
        showingInfoWindow: false,
        activeMarker: {},
        selectedPlace: {},
    }

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        })

    onMapClicked = (props) => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            })
        }
    }

    render() {
        const { properties } = this.props
        const { activeMarker, showingInfoWindow, selectedPlace } = this.state



        return (
            <div style={{ width: '100%', height: '650px', position: 'relative' }}>
                <Label>Total de propiedades encontradas: <strong>{properties.length}</strong></Label>
                <Map
                    google={this.props.google}
                    zoom={13}
                    className={'map'}
                    initialCenter={{
                        lat: 19.6964754,
                        lng: -101.1953352
                    }}
                    onClick={this.onMapClicked}
                >

                    {properties && properties.map((property, key) =>
                        <Marker
                            property={property}
                            position={{ lat: property.latitude, lng: property.longitude }}
                            key={key}
                            onClick={this.onMarkerClick}
                        />
                    )}

                    {<InfoWindow
                        marker={activeMarker}
                        visible={showingInfoWindow}>
                        <div>
                            {selectedPlace && selectedPlace.property &&
                                <div>
                                    <p>
                                        <Label>{selectedPlace.property.title}</Label>
                                        <br />
                                        Huéspedes: <Label>{selectedPlace.property.accommodates}</Label>
                                        <br />
                                        Habitaciones: <Label>{selectedPlace.property.accommodates}</Label>
                                        <br />
                                        Baños: <Label>{selectedPlace.property.bathrooms}</Label>
                                        <br />
                                        Tipo: <Label>{selectedPlace.property.property_type}</Label>
                                        <br />
                                        Reviews: <Label>{selectedPlace.property.reviews}</Label>
                                        <br />
                                        Ocupación: <Label>{selectedPlace.property.occ * 100} %</Label>
                                        <br />
                                        Ingresos: <strong><CurrencyMX quantity={selectedPlace.property.revenue} /></strong>
                                        <br />
                                        <a href={`https://www.airbnb.mx/rooms/${selectedPlace.property.airbnb_property_id}`} rel="noopener noreferrer" target="_blank">Airbnb</a>
                                    </p>
                                </div>
                            }
                        </div>
                    </InfoWindow>}
                </Map>
            </div>
        )
    }
}

export default GoogleApiWrapper({
    apiKey: google_maps_key,
    v: "3.30"
})(MapProperties)